import { render, staticRenderFns } from "./PrivacyHeader.vue?vue&type=template&id=5bafca4e&"
import script from "./PrivacyHeader.vue?vue&type=script&lang=js&"
export * from "./PrivacyHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports